const moreBetTypes = {
  0: 'RED_2',
  1: 'BLACK_2',
  2: '2',
  4: 'RED_3',
  5: 'BLACK_3',
  6: '3',
  9: 'RED_4',
  10: 'BLACK_4',
  11: '4',
  14: 'RED_5',
  15: 'BLACK_5',
  16: '5',
  19: 'RED_6',
  20: 'BLACK_6',
  21: '6',
  24: 'RED_7',
  25: 'BLACK_7',
  26: '7',
  29: 'RED_8',
  30: 'BLACK_8',
  31: '8',
  34: 'RED_9',
  35: 'BLACK_9',
  36: '9',
  39: 'RED_J',
  40: 'BLACK_J',
  41: 'J',
  44: 'RED_Q',
  45: 'BLACK_Q',
  46: 'Q',
  49: 'RED_K',
  50: 'BLACK_K',
  51: 'K',
  54: 'RED_A',
  55: 'BLACK_A',
  56: 'A',
};

Object.freeze(moreBetTypes);

const mainBetTypes = {
  61: {
    type: 'JOKER',
    styleId: '1',
  },
  58: {
    type: 'RED',
    styleId: '2',
  },
  59: {
    type: 'BLACK',
    styleId: '3',
  },
  60: {
    type: '2-9',
    styleId: '4',
  },
  62: {
    type: 'J,Q,K,A',
    styleId: '4',
  },
  63: {
    type: 'J,Q',
    styleId: '4',
  },
  64: {
    type: 'K,A',
    styleId: '4',
  },
};

Object.freeze(mainBetTypes);

const hiLoBetTypes = {
  3: 'HIGH_2',
  7: 'HIGH_3',
  8: 'LO_3',
  12: 'HIGH_4',
  13: 'LO_4',
  17: 'HIGH_5',
  18: 'LO_5',
  22: 'HIGH_6',
  23: 'LO_6',
  27: 'HIGH_7',
  28: 'LO_7',
  32: 'HIGH_8',
  33: 'LO_8',
  37: 'HIGH_9',
  38: 'LO_9',
  42: 'HIGH_J',
  43: 'LO_J',
  47: 'HIGH_Q',
  48: 'LO_Q',
  52: 'HIGH_K',
  53: 'LO_K',
  57: 'LO_A',
};

Object.freeze(hiLoBetTypes);

const betTypesNames = {
  Red: 'RED',
  Black: 'BLACK',
  K_A: 'GAME_RULES_P81',
  J_Q: 'GAME_RULES_P86',
  Red_2: 'GAME_RULES_P85',
  Joker: 'GAME_RULES_P83',
  J_Q_K_A: 'GAME_RULES_P80',
  Black_2: 'GAME_RULES_P84',
  Number_2: 'GAME_RULES_P82',
  Numbers_2_to_9: 'GAME_RULES_P79',
};

Object.freeze(betTypesNames);

export { mainBetTypes, moreBetTypes, hiLoBetTypes, betTypesNames };
